/**
 * @generated SignedSource<<67921d675b5d807e7a4b27cb618ccf42>>
 * @relayHash 0545ddb77abd8407f2071acc8b78d28f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e7d8e016e3df0914d15e46964255ad8e9852ea7c2db4943ee6b8afbfd6e86829

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type IssueHistoryQuery$variables = {
  after?: string | null | undefined;
  before?: string | null | undefined;
  cloudId: string;
  first?: number | null | undefined;
  issueKey: string;
  last?: number | null | undefined;
  orderBy?: string | null | undefined;
};
export type IssueHistoryQuery$data = {
  readonly jira: {
    readonly issueByKey: {
      readonly " $fragmentSpreads": FragmentRefs<"IssueHistoryFragment">;
    };
  } | null | undefined;
};
export type IssueHistoryQuery = {
  response: IssueHistoryQuery$data;
  variables: IssueHistoryQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "before"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "issueKey"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "last"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "orderBy"
},
v7 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "key",
    "variableName": "issueKey"
  }
],
v8 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "before",
    "variableName": "before"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "last",
    "variableName": "last"
  },
  {
    "kind": "Variable",
    "name": "orderBy",
    "variableName": "orderBy"
  }
],
v9 = {
  "kind": "ScalarField",
  "name": "id"
},
v10 = {
  "kind": "ScalarField",
  "name": "type"
},
v11 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v12 = {
  "kind": "ScalarField",
  "name": "formattedValue"
},
v13 = {
  "kind": "ScalarField",
  "name": "displayValue"
},
v14 = {
  "kind": "ScalarField",
  "name": "value"
},
v15 = {
  "kind": "ScalarField",
  "name": "avatarUrl"
},
v16 = {
  "kind": "ScalarField",
  "name": "name"
},
v17 = [
  (v11/*: any*/),
  {
    "kind": "InlineFragment",
    "selections": [
      (v12/*: any*/),
      {
        "kind": "ScalarField",
        "name": "categoryId"
      },
      (v13/*: any*/),
      (v14/*: any*/)
    ],
    "type": "JiraHistoryStatusFieldValue"
  },
  {
    "kind": "InlineFragment",
    "selections": [
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      {
        "concreteType": "JiraWorklog",
        "kind": "LinkedField",
        "name": "worklog",
        "plural": false,
        "selections": [
          (v9/*: any*/),
          {
            "kind": "ScalarField",
            "name": "worklogId"
          },
          {
            "concreteType": "JiraEstimate",
            "kind": "LinkedField",
            "name": "timeSpent",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "timeInSeconds"
              }
            ]
          },
          {
            "concreteType": "JiraRichText",
            "kind": "LinkedField",
            "name": "workDescription",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraADF",
                "kind": "LinkedField",
                "name": "adfValue",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "json"
                  },
                  {
                    "concreteType": "JiraAdfToConvertedPlainText",
                    "kind": "LinkedField",
                    "name": "convertedPlainText",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "plainText"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "JiraHistoryWorkLogFieldValue"
  },
  {
    "kind": "InlineFragment",
    "selections": [
      (v12/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/),
      (v13/*: any*/)
    ],
    "type": "JiraHistoryAssigneeFieldValue"
  },
  {
    "kind": "InlineFragment",
    "selections": [
      (v14/*: any*/),
      (v13/*: any*/),
      (v12/*: any*/),
      {
        "kind": "ScalarField",
        "name": "iconUrl"
      },
      {
        "kind": "ScalarField",
        "name": "absoluteIconUrl"
      }
    ],
    "type": "JiraHistoryPriorityFieldValue"
  },
  {
    "kind": "InlineFragment",
    "selections": [
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      {
        "concreteType": "JiraHistoryResponder",
        "kind": "LinkedField",
        "name": "responders",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "ari"
          },
          (v16/*: any*/),
          (v10/*: any*/),
          (v15/*: any*/)
        ]
      }
    ],
    "type": "JiraHistoryRespondersFieldValue"
  },
  {
    "kind": "InlineFragment",
    "selections": [
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/)
    ],
    "type": "JiraHistoryGenericFieldValue"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Fragment",
    "name": "IssueHistoryQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": {
              "args": (v7/*: any*/),
              "concreteType": "JiraIssue",
              "kind": "LinkedField",
              "name": "issueByKey",
              "plural": false,
              "selections": [
                {
                  "kind": "FragmentSpread",
                  "name": "IssueHistoryFragment"
                }
              ]
            },
            "action": "THROW",
            "path": "jira.issueByKey"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v4/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v0/*: any*/),
      (v5/*: any*/),
      (v1/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Operation",
    "name": "IssueHistoryQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v7/*: any*/),
            "concreteType": "JiraIssue",
            "kind": "LinkedField",
            "name": "issueByKey",
            "plural": false,
            "selections": [
              {
                "args": (v8/*: any*/),
                "concreteType": "JiraIssueHistoryConnection",
                "kind": "LinkedField",
                "name": "history",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraIssueHistoryEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraHistoryActivityFeedItem",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v9/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "i18nDescription"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "fieldDisplayName"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "fieldId"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "fieldType"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "timestamp"
                          },
                          {
                            "concreteType": "JiraHistoryFieldSchema",
                            "kind": "LinkedField",
                            "name": "fieldSchema",
                            "plural": false,
                            "selections": [
                              (v10/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "customFieldType"
                              }
                            ]
                          },
                          {
                            "kind": "ScalarField",
                            "name": "isDueToRedaction"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "isDueToRedactionRestore"
                          },
                          {
                            "kind": "LinkedField",
                            "name": "from",
                            "plural": false,
                            "selections": (v17/*: any*/)
                          },
                          {
                            "kind": "LinkedField",
                            "name": "to",
                            "plural": false,
                            "selections": (v17/*: any*/)
                          },
                          {
                            "kind": "LinkedField",
                            "name": "actor",
                            "plural": false,
                            "selections": [
                              (v11/*: any*/),
                              (v16/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "accountId"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "picture"
                              },
                              (v9/*: any*/)
                            ]
                          },
                          (v11/*: any*/)
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "name": "cursor"
                      }
                    ]
                  },
                  {
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "hasNextPage"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "hasPreviousPage"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "endCursor"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "startCursor"
                      }
                    ]
                  }
                ]
              },
              {
                "args": (v8/*: any*/),
                "filters": [
                  "orderBy"
                ],
                "handle": "connection",
                "key": "IssueHistory_history",
                "kind": "LinkedHandle",
                "name": "history"
              },
              (v9/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "e7d8e016e3df0914d15e46964255ad8e9852ea7c2db4943ee6b8afbfd6e86829",
    "metadata": {},
    "name": "IssueHistoryQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "909f36efa1b2ba088df4e2d00baf9607";

export default node;
